import React from 'react';
import Catalog from '~/Catalog';
import Link from '~/components/molecule/Link';

import {
  safeFormattedDateTime,
  convertServerDateStringToDate,
} from '~/util/date';

export type Props = {
  /** Null if the api key is not connected, otherwise Date string */
  lastConnectedAt?: string | null;
};

const text = {
  goTo: 'Ga naar ',
  myApps: 'My Apps',
  stepsToFollow: ` , klik “Add connection”, zoek op “${Catalog.companyName}”, plak de api key. Daarna ververs deze pagina.`,
  lastConnectedAt: 'Laatst verbonden op ',
};

const Description: React.FCC<Props> = ({ dataTestId, lastConnectedAt }) => {
  const formattedDate = safeFormattedDateTime(
    convertServerDateStringToDate(lastConnectedAt),
  );

  if (lastConnectedAt && lastConnectedAt.length > 0)
    return (
      <span data-testid={dataTestId}>
        {text.lastConnectedAt}
        {formattedDate}
      </span>
    );

  return (
    <span data-testid={dataTestId}>
      {text.goTo}
      <Link to="https://zapier.com/app/connections" target="_blank">
        {text.myApps}
      </Link>
      {text.stepsToFollow}
    </span>
  );
};

export default Description;
